import Vue from 'vue'
import Home from './components/layouts/Home.vue'
import axios from 'axios'
import store from './store'
import moment from 'moment-timezone';

import './assets/fonts/PizzaProsto/PizzaProsto.css'
import './assets/scss/main.scss';

import VueMask from 'v-mask'
Vue.use(VueMask);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

Vue.prototype.$http = axios;

moment.tz.setDefault('Asia/Vladivostok');
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;

import VueWindowSize from 'vue-window-size';
Vue.use(VueWindowSize);

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {offset: -100,});

const expiredCookie = '30d';
Vue.$cookies.config(expiredCookie);
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
});

import VueRouter from 'vue-router'
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
});

new Vue({
  store,
  router,
  render: h => h(Home),
}).$mount('#app');
